{
  "loginTitle": "Login",
  "emailPlaceholder": "E-mail",
  "passwordPlaceholder": "Senha",
  "loginButton": "Entrar",
  "forgotPassword": "Esqueceu sua senha?",
  "signupPrompt": "Não tem uma conta?",
  "signupLink": "Cadastrar",
  "loading": "Carregando...",
  "emailVerifiedSuccessfully": "E-mail verificado com sucesso!",
  "resetPasswordTitle": "Redefinir Senha",
  "resetPasswordButton": "Enviar link de redefinição",
  "passwordReset": {
    "success": "Se existir uma conta com este e-mail, você receberá instruções para redefinir a senha.",
    "failed": "Não foi possível enviar o e-mail de redefinição de senha.",
    "error": "Ocorreu um erro ao solicitar a redefinição de senha. Por favor, tente novamente."
  },
  "passwordResetSuccess": "Sua senha foi redefinida com sucesso. Por favor, faça login com sua nova senha.",
  "passwordResetInvalid": "Link de redefinição de senha inválido. Por favor, solicite um novo.",
  "passwordResetError": "Ocorreu um erro ao redefinir sua senha. O link pode ter expirado.",
  "invalidCredentials": "Email ou senha incorretos.",
  "networkError": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
  "serverUnavailable": "Servidor indisponível no momento. Tente novamente em instantes.",
  "loginError": "Ocorreu um erro durante o login. Por favor, tente novamente.",
  "privacyInfo": {
    "title": "Seus dados estão protegidos",
    "body": "Ao continuar, você concorda com os",
    "termsLink": "Termos de Serviço",
    "privacyLink": "Política de Privacidade"
  },
  "magicLink": {
    "cta": "Entrar com link por e-mail",
    "sentTitle": "Verifique seu e-mail",
    "sentBody": "Se existir uma conta associada a {{email}}, enviamos um link de acesso. Abra o link para entrar — ele é válido por 15 minutos e só pode ser usado uma vez.",
    "sentBodyNoEmail": "Se existir uma conta associada a esse e-mail, enviamos um link de acesso. Abra o link para entrar — ele é válido por 15 minutos e só pode ser usado uma vez.",
    "resend": "Reenviar link",
    "resent": "Link reenviado.",
    "backToLogin": "Voltar ao login",
    "emailRequired": "Digite seu e-mail para receber um link de acesso.",
    "requestError": "Não foi possível enviar o link. Tente novamente."
  }
} 